import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  Flex,
  Button,
  Text,
  Box,
  Spinner,
  useToast,
} from '@chakra-ui/react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import FormikInput from '../../components/formikinput';
import FormikSelect from '../../components/forkmikselect';
import useAddAdminMutation from '../../api/mutations/useAddAdminMutation';

const AddAdminModal = ({ isOpen, onClose, onAddAdmin }) => {
  const toast = useToast();

  const addAdminMutation = useAddAdminMutation({
    onSuccess: (data) => {
      toast({
        title: 'Employee added successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      onAddAdmin?.(data);
      formik.resetForm();
      onClose();
    },
    onError: (error) => {
      toast({
        title: error?.response?.data?.message || 'Failed to add employee',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    },
  });

  const formik = useFormik({
    initialValues: {
      first_name: '',
      last_name: '',
      email: '',
      role: 'employee',
      verify: true,
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required('First name is required'),
      last_name: Yup.string().required('Last name is required'),
      email: Yup.string().email('Invalid email address').required('Email is required'),
      role: Yup.string().required('Role is required'),
    }),
    onSubmit: values => {
      console.log('Submitting values:', values);
      addAdminMutation.mutate(values);
    },
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        minH={'200px'}
        maxW={'500px'}
        borderRadius={16}
        padding={4}
        gap={8}
      >
        <ModalBody display={'flex'} flexDirection={'column'} gap={6}>
          <Text
            fontFamily={'PlusJakartaSansSemiBold'}
            fontSize={'24px'}
            lineHeight={'32px'}
            textTransform={'capitalize'}
            color={'#000000'}
          >
            Add User
          </Text>
          <Box height="1px" width="100%" bg="#8A8F9333" mx="auto" />
          <Flex direction={'column'} gap={4}>
            <Flex gap={4}>
              <FormikInput
                formik={formik}
                name={'first_name'}
                label={'First Name'}
                placeholder={'Enter first name'}
              />
              <FormikInput
                formik={formik}
                name={'last_name'}
                label={'Last Name'}
                placeholder={'Enter last name'}
              />
            </Flex>
            <FormikInput
              formik={formik}
              name={'email'}
              label={'Email'}
              placeholder={'Enter employee email'}
              type={'email'}
            />
            <FormikSelect
              formik={formik}
              name="role"
              label="Role"
            >
              <option value="employee">Employee</option>
              <option value="owner">Owner</option>
            </FormikSelect>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Flex w={'100%'} justify={'flex-end'} gap={4}>
            <Button
              bg={'white'}
              border={'1px solid #000000'}
              color="#000000"
              borderRadius={8}
              paddingInline={16}
              textTransform={'uppercase'}
              onClick={onClose}
            >
              Close
            </Button>
            <Button
              onClick={formik.handleSubmit}
              isDisabled={addAdminMutation.isLoading}
              bg={'#000000'}
              color="#FFFFFF"
              borderRadius={8}
              paddingInline={16}
              textTransform={'uppercase'}
              border={'1px solid #FFFFFF'}
            >
              {addAdminMutation.isLoading ? <Spinner size="sm" /> : 'Add'}
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddAdminModal;
